<template>
  <v-card>
    <v-card-title>オプション</v-card-title>

    <v-card-text>
      <template v-if="bookInsurance.id !== 0">
        <h3>補償サービス</h3>
        <confirm-item :label="bookInsurance.name" :charge="bookInsurance.charge"/>
      </template>

      <template v-if="bookOptions.length > 0">
        <h3>オプション</h3>
        <confirm-item
          v-for="item in bookOptions"
          :key="item.id"
          :label="item.name" :quantity="item.quantity" :charge="item.charge"
        />
      </template>

      <template v-if="bookGears.length > 0">
        <h3>レンタルギア</h3>
        <confirm-item
          v-for="item in bookGears"
          :key="item.id"
          :label="item.name" :quantity="item.quantity" :charge="item.charge"
        />
      </template>

      <template v-if="bookLocation.id !== 0">
        <h3>ワンウェイサービス</h3>
        <confirm-item :label="'返却先: ' + bookLocation.name" :charge="bookLocation.charge"/>
      </template>

      <template v-if="bookPick">
        <h3>送迎サービス</h3>
        <confirm-item :label="bookPick.name" :charge="bookPick.charge"/>
      </template>

      <template v-if="bookDeli">
        <h3>配車サービス</h3>
        <confirm-item :label="bookDeli.name" :charge="bookDeli.charge"/>
      </template>

      <hr class="has-space">
      <confirm-item em label="追加料金 小計" :charge="bookCharge.additional"/>
    </v-card-text>
  </v-card>
</template>

<script>
import PartBase from '@/mixins/PartBase'
import ConfirmItem from './ConfirmItem'
import { mapGetters } from 'vuex'

export default {
  name: 'ConfirmCharge',
  mixins: [
    PartBase
  ],
  components: {
    ConfirmItem
  },
  computed: {
    ...mapGetters('book', [
      'bookInsurance',
      'bookPick',
      'bookDeli',
      'bookOptions',
      'bookLocation',
      'bookGears',
      'bookCharge'
    ])
  }
}
</script>
